import { getDefaultConfigurationValues } from "@utils/search/defaultConfiguration";

import createValueModule from "@redux/create-value-module";

import { $SearchModuleName, SearchState, SearchStatus } from "./search.types";

const initialState: SearchState = {
    status: SearchStatus.Loading,
    configuration: {
        userToken: undefined,
        components: getDefaultConfigurationValues(),
    },
    results: [],
};

const { constants: _constants, actions } = createValueModule<SearchState>(
    $SearchModuleName,
    initialState,
);

export const clear = actions.clear;
export const set = actions.set;
export const update = actions.update;

export const constants = _constants;
